import { render, staticRenderFns } from "./VideoPlayer.component.vue?vue&type=template&id=097dbef1&scoped=true&"
import script from "./VideoPlayer.component.vue?vue&type=script&lang=js&"
export * from "./VideoPlayer.component.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayer.component.vue?vue&type=style&index=0&id=097dbef1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097dbef1",
  null
  
)

export default component.exports